import WithAuthentication from './WithAuthentication';

export default WithAuthentication;
